import { Typography } from "@mui/material";
import React from "react";
import { StoreData } from "../../Objects/StoreInterface";

interface StoreNameProps {
    storeData: StoreData
}

const StoreName: React.FC<StoreNameProps> = ({
    storeData
}) => {
    return (
        <>
            <Typography
                variant="h6"
            >
                {storeData.str_name}
            </Typography>
        </>
    );
}

export default StoreName